<template>
  <div class="is-taisyokukin detail-item" v-if="editingData">

    <div class="head"><b>退職金</b></div>
    <div class="data">
      <p v-if="editingData.is_taisyokukin === false">無</p>
    </div>
    <!-- PMの場合は退職金は常にfalseとするが、念の為DB値を表示する様にしています -->

  </div>
</template>

<script lang="ts">
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-detail.scss';

</style>
